const API_URL = process.env.REACT_APP_API_URL;

export const stripeService = {
  /**
   * Create Stripe Connect account
   */
  async createConnectAccount() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/stripe/connect/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating Stripe account:", error);
      throw error;
    }
  },

  /**
   * Get onboarding link
   */
  async getOnboardingLink() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${API_URL}/api/stripe/connect/onboarding-link`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error getting onboarding link:", error);
      throw error;
    }
  },

  /**
   * Get Stripe account status
   */
  async getAccountStatus() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/stripe/connect/status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error getting account status:", error);
      throw error;
    }
  },

  /**
   * Get dashboard login link
   */
  async getDashboardLink() {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${API_URL}/api/stripe/connect/dashboard`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error getting dashboard link:", error);
      throw error;
    }
  },

  /**
   * Create payment link for LBA
   */
  async createPaymentLink(lbaId) {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        `${API_URL}/api/stripe/payment-link/${lbaId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result.message);
      return result;
    } catch (error) {
      console.error("Error creating payment link:", error);
      throw error;
    }
  },
  async disconnectAccount() {
  try {
    const token = localStorage.getItem("authToken");
    const response = await fetch(`${API_URL}/api/stripe/connect/disconnect`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message);
    return result;
  } catch (error) {
    console.error("Error disconnecting Stripe account:", error);
    throw error;
  }
},
};
